enum SalePriceItemType {
    ARTICLE = "ARTICLE",
    TOPUP = "TOPUP",
    MONEY = "MONEY",
    MISCELLANY = "MISCELLANY",
    PACKAGE_REFERENCE_ITEM = "PACKAGE_REFERENCE_ITEM",
    PACKAGE_CUSTOM_CATEGORY_WEIGHT_RANGE = "PACKAGE_CUSTOM_CATEGORY_WEIGHT_RANGE",
}

export default SalePriceItemType;
